"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsDiscountViewModel = instanceOfProductPromotionsDiscountViewModel;
exports.ProductPromotionsDiscountViewModelFromJSON = ProductPromotionsDiscountViewModelFromJSON;
exports.ProductPromotionsDiscountViewModelFromJSONTyped = ProductPromotionsDiscountViewModelFromJSONTyped;
exports.ProductPromotionsDiscountViewModelToJSON = ProductPromotionsDiscountViewModelToJSON;
exports.ProductPromotionsDiscountViewModelToJSONTyped = ProductPromotionsDiscountViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsDiscountViewModel interface.
 */
function instanceOfProductPromotionsDiscountViewModel(value) {
    return true;
}
function ProductPromotionsDiscountViewModelFromJSON(json) {
    return ProductPromotionsDiscountViewModelFromJSONTyped(json, false);
}
function ProductPromotionsDiscountViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'promotionsNo': json['promotionsNo'] == null ? undefined : json['promotionsNo'],
        'discountName': json['discountName'] == null ? undefined : json['discountName'],
        'discountCode': json['discountCode'] == null ? undefined : json['discountCode'],
        'useWay': json['useWay'] == null ? undefined : json['useWay'],
        'discountWay': json['discountWay'] == null ? undefined : json['discountWay'],
        'fullAmount': json['fullAmount'] == null ? undefined : json['fullAmount'],
        'minQuantity': json['minQuantity'] == null ? undefined : json['minQuantity'],
        'discountValue': json['discountValue'] == null ? undefined : json['discountValue'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
        'promotionName': json['promotionName'] == null ? undefined : json['promotionName'],
        'promotionCode': json['promotionCode'] == null ? undefined : json['promotionCode'],
        'promotionStart': json['promotionStart'] == null ? undefined : json['promotionStart'],
        'promotionEnd': json['promotionEnd'] == null ? undefined : json['promotionEnd'],
    };
}
function ProductPromotionsDiscountViewModelToJSON(json) {
    return ProductPromotionsDiscountViewModelToJSONTyped(json, false);
}
function ProductPromotionsDiscountViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'promotionsNo': value['promotionsNo'],
        'discountName': value['discountName'],
        'discountCode': value['discountCode'],
        'useWay': value['useWay'],
        'discountWay': value['discountWay'],
        'fullAmount': value['fullAmount'],
        'minQuantity': value['minQuantity'],
        'discountValue': value['discountValue'],
        'useStatus': value['useStatus'],
        'promotionName': value['promotionName'],
        'promotionCode': value['promotionCode'],
        'promotionStart': value['promotionStart'],
        'promotionEnd': value['promotionEnd'],
    };
}
